export default "__VITE_ASSET__BuZNuD1x__"